import type { ReactNode } from "react";

import { TopNav } from "@/components/shared/navigation/top-nav";
import { NavigationProgress } from "@/components/shared/navigation-progress/navigation-progress";
import { cn } from "@/lib/utils";

interface AppShellProps {
  children: ReactNode;
  fullBleed?: boolean;
}

/** Top-level layout for the authenticated console surfaces. */
export function AppShell({ children, fullBleed = false }: AppShellProps) {
  return (
    <div className="flex min-h-screen flex-col bg-bg-canvas">
      <NavigationProgress />
      <TopNav />
      <main className={cn("flex-1 overflow-y-auto", !fullBleed && "p-6 sm:p-9")}>
        {children}
      </main>
    </div>
  );
}
